import React, { useState } from 'react';
import { Form, Container, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { MdKeyboardArrowRight, MdFileUpload } from "react-icons/md";
import image from '../../../../assets/image-admin/Image.png';
import './AjouVendeur.css';
import { Link, NavLink, useParams, useLocation, useNavigate} from 'react-router-dom';
import { BsArrowLeft } from "react-icons/bs";


const DetailVendeurs = () => {
  const { slug } = useParams<{ slug: string }>();
  let { state } = useLocation();
  const navigate = useNavigate();


  return (
    <div className="form-register-tabs-component mt-10">
      
      <div className="content-detail-commande-page m-5 ">
        <div className="row">
          <div className="content-title-form-register pb-4">
            <h3
              className="title-form-register mt-5"
              style={{ cursor: "pointer" }}
            >
              <span className="">Details Vendeur</span>{" "}
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3 col-left-detail-commande">
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Non du Vendeur</h3>
                <div className="sm-value">
                  {state?.prenom + " " + state?.nom}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Email</h3>
                <div className="sm-value">
                  {state?.email}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">
                  Téléphone
                </h3>
                <div className="sm-value">
                  {state?.telephone}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">
                  Couleur
                </h3>
                <div className="sm-value">
                  {state?.couleur}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">
                  Wave api key
                </h3>
                <div className="sm-value">
                  {state?.wave_api_key ? state?.wave_api_key : "non renseigné."}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">
                  Stripe publishable key
                </h3>
                <div className="sm-value">
                  {state?.stripe_publishable_key  ? state?.stripe_publishable_key : "non renseigné."}
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">
                  Stripe secret key
                </h3>
                <div className="sm-value">
                  {state?.stripe_secret_key ? state?.stripe_secret_key : "non renseigné." }
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3 col-right-detail-commande">
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Nom de la boutique</h3>
                <div className="sm-value">
                  {state?.nom_de_la_boutique }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Pays</h3>
                <div className="sm-value">
                  {state?.pays }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Adresse</h3>
                <div className="sm-value">
                  {state?.adresse }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Domaine</h3>
                <div className="sm-value">
                  {state?.domaine }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Wave api secret key</h3>
                <div className="sm-value">
                  {state?.wave_api_secret_key ? state?.wave_api_secret_key : "non renseigné." }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Stripe endpoint secret</h3>
                <div className="sm-value">
                  {state?.stripe_endpoint_secret ? state?.stripe_endpoint_secret : "non renseigné." }
                </div>
              </div>
            </div>
            <div className="card-detail-commande-item mb-3">
              <div className="content-col-detail-commande-admin">
                <h3 className="title-col-detail-commande-admin">Devise</h3>
                <div className="sm-value">
                  {state?.devise }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailVendeurs;
